const actionTypes = {
    SET_PACE_PERCENT: "SET_PACE_PERCENT",
    START_PACE: "START_PACE",
    END_PACE: "END_PACE"
};


export const setPacePercent = (requestId, percentDown, percentUp) => {
    return {type: actionTypes.SET_PACE_PERCENT, requestId, percentUp, percentDown};
}
export const endPace = (requestId) => {
    return {type: actionTypes.END_PACE, requestId};
}
export const startPace = (requestId) => {
    return {type: actionTypes.START_PACE, requestId};
}

export default actionTypes;